export default __webpack_public_path__ + "static/media/single_device.0fc52dc2.svg";